var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00091 0.766602C11.9958 0.766602 15.2342 4.00508 15.2342 7.99994C15.2342 11.9948 11.9958 15.2333 8.00091 15.2333C4.00605 15.2333 0.767578 11.9948 0.767578 7.99994C0.767578 4.00508 4.00605 0.766602 8.00091 0.766602ZM8.00091 1.89994C4.63197 1.89994 1.90091 4.631 1.90091 7.99994C1.90091 11.3689 4.63197 14.0999 8.00091 14.0999C11.3698 14.0999 14.1009 11.3689 14.1009 7.99994C14.1009 4.631 11.3698 1.89994 8.00091 1.89994ZM8.00091 7.43327C8.2898 7.43327 8.5282 7.64944 8.56316 7.92885L8.56758 7.99994V10.6666C8.56758 10.9796 8.31387 11.2333 8.00091 11.2333C7.71202 11.2333 7.47363 11.0171 7.43866 10.7377L7.43425 10.6666V7.99994C7.43425 7.68697 7.68795 7.43327 8.00091 7.43327ZM8.00758 4.7666C8.32054 4.7666 8.57424 5.02031 8.57424 5.33327C8.57424 5.62216 8.35807 5.86055 8.07866 5.89552L8.00091 5.89993C7.68795 5.89993 7.43425 5.64623 7.43425 5.33327C7.43425 5.04438 7.65042 4.80598 7.92983 4.77102L8.00758 4.7666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.bb55655b7abd2f4f0defd65e35304dfd.svg";
export { ForwardRef as ReactComponent };